import { Button, ButtonProps } from './button';
import { createIcon, icons } from './icons';
import { UiComponent, UiComponentProps } from './ui-component';

export type CloseButtonProps = UiComponentProps &
	ButtonProps & {
		iconClassNames?: string[];
	};

export class CloseButton extends UiComponent<CloseButtonProps> {
	render(): HTMLButtonElement {
		const { onClick } = this.props;
		const button = new Button({ onClick, classNames: this.getClassNames() }).render();
		const closeIcon = createIcon(icons.CROSS, ['icon', ...this.getIconClassNames()]);

		if (closeIcon) {
			button.appendChild(closeIcon);
		}

		return button;
	}

	getClassNames(): string[] {
		return ['button-close', ...super.getClassNames()];
	}

	private getIconClassNames(): string[] {
		return this.props?.iconClassNames ?? [];
	}
}
